module.exports = __webpack_public_path__ + "static/repair1-117345d11fd8328e4b1559d0251ffd01.jpg";